import { blobHref, proxyUrl } from '@shared/utils';
import { ITEM_MIMETYPES } from '../constants';
import { downloadFile } from '@modules/files';
import { EHandlePdfBlobMode } from '../types/items.types';

/**
 * Handles the PDF blob by either opening it in a new tab or downloading it.
 *
 * @param containerId - Item (file/document) name
 * @param blobName - Blob name from Azure
 * @param token - Access token for Azure
 * @param mode - Mode to handle the blob (view or download)
 * @param filename - Filename to use for the downloaded file
 */
const handlePdfBlob = async (
  containerId: string,
  blobName: string,
  token: string,
  mode: EHandlePdfBlobMode,
  filename: string
) => {
  const href = blobHref(containerId, blobName, token);
  const mimetype = ITEM_MIMETYPES.pdf[0];
  const proxy = proxyUrl(href, filename, mimetype, mode === EHandlePdfBlobMode.VIEW);

  if (mode === EHandlePdfBlobMode.VIEW) {
    window.open(proxy, '_blank');
  } else {
    downloadFile(href, mimetype, filename);
  }
};

export default handlePdfBlob;
